import { useCallback, useEffect } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'
import { toast } from 'sonner'

export const usePWA = () => {
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegistered(r) {
      console.log('SW Registered:', r)

      if (r) {
        setInterval(
          () => {
            console.log('Checking for SW updates...')
            r.update()
          },
          60 * 60 * 1000,
        )
      }
    },
    onRegisterError(error) {
      console.error('SW registration error:', error)
    },
    immediate: true,
  })

  const handleUpdate = useCallback(() => {
    console.log('Updating service worker...')
    updateServiceWorker(true)
    setNeedRefresh(false)
  }, [updateServiceWorker, setNeedRefresh])

  useEffect(() => {
    if (needRefresh) {
      console.log('New version available!')

      toast.info('New version available!', {
        action: {
          label: 'Update Now',
          onClick: handleUpdate,
        },
        cancel: {
          label: 'Later',
          onClick: () => {
            setNeedRefresh(false)

            setTimeout(
              () => {
                toast.info('Update still available', {
                  action: {
                    label: 'Update',
                    onClick: handleUpdate,
                  },
                })
              },
              60 * 60 * 1000,
            )
          },
        },
        duration: Infinity,
      })
    }
  }, [needRefresh, handleUpdate, setNeedRefresh])

  useEffect(() => {
    const handleOnline = () => {
      console.log('App is online, checking for updates...')
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistration().then((reg) => {
          if (reg) {
            reg.update()
          }
        })
      }
    }

    window.addEventListener('online', handleOnline)

    return () => {
      window.removeEventListener('online', handleOnline)
    }
  }, [])

  return {
    needRefresh,
    updateServiceWorker: handleUpdate,
  }
}
